var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42848 1.71429C4.4817 1.71429 3.71419 2.4818 3.71419 3.42857V4.28571H7.14276V3.42857C7.14276 2.4818 6.37525 1.71429 5.42848 1.71429ZM1.9999 3.42857V4.28571H1.57136C0.861276 4.28571 0.285645 4.86135 0.285645 5.57143V10.7143C0.285645 11.4243 0.861276 12 1.57136 12H9.28564C9.9957 12 10.5714 11.4243 10.5714 10.7143V5.57143C10.5714 4.86135 9.9957 4.28571 9.28564 4.28571H8.85707V3.42857C8.85707 1.53502 7.32202 0 5.42848 0C3.53493 0 1.9999 1.53502 1.9999 3.42857ZM5.4285 9.21429C6.02024 9.21429 6.49993 8.73463 6.49993 8.14286C6.49993 7.55112 6.02024 7.07143 5.4285 7.07143C4.83676 7.07143 4.35707 7.55112 4.35707 8.14286C4.35707 8.73463 4.83676 9.21429 5.4285 9.21429Z",
    fill: "#9D96AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2d7dcc8d64c1ddb9de2d23749fd2896c.svg";
export { ForwardRef as ReactComponent };